'use client';

import { useEffect, useState } from 'react';

import { useParams } from 'react-router-dom';
import { useLocalStorage } from 'react-use';

import { TemplatePage } from '../components/TemplatePage';

export default function Page(props: any) {
  const { id } = useParams();
  const [cacheData] = useLocalStorage<any>(id!, {});
  const [data, setData] = useState({});
  useEffect(() => {
    if (id) {
      setData({ ...cacheData, addFieldsData: cacheData?.addFieldsData || {} });
    }
  }, [id]);
  return <TemplatePage {...props} data={data} />;
}
